import styled from "styled-components";
import { Card, Tab, Button } from "react-bootstrap";

export const Container = styled.span`
  input {
    width: 0;
  }
  .form-group {
    margin-bottom: 0px;
  }
`;

export const WitLabel = styled.label`
  display: block;
  width: 100%;
  padding: 0;
  margin: 30px 0 20px 0;
  font-size: 21px;
  line-height: inherit;
  color: #3a3f51;
  border: 0;

  border-bottom: 1px solid #e5e5e5;
`;

export const PackagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: transparent;
`;

export const ErrorField = styled.div`
  width: 100%;
  margin-top: 10px;
  background-color: #f5abba;
  border-radius: 5px;
  padding: 2px 5px;
  color: #6e0218;
`;

export const StyledCard = styled(Card)`
  margin: 22px;
  .nav-tabs .errorTab .nav-link.active {
    background-color: #fbb4ac;
    border: 1px solid #fb6d81;
  }
`;

export const StyledTabs = styled(Tab.Container)``;

export const StyledBackButton = styled(Button)`
  background-color: #edeff2 !important;
  color: #212529 !important;
`;
